import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import { css } from '@emotion/css';
import { theme, setDefault } from '../../styles/theme';
import { deepDefaults, getLeft, setAlpha } from '../../styles/utils';
import '../../styles/global';
import { menu } from '../menu/styles';
import { isNullOrUndefined } from 'intact-shared';
import { getStyle } from './helpers';
import { cache } from '../utils';
var sizes = ['small', 'large'];
export var themes = ['light', 'dark', 'white'];
var defaults = {
  get transition() {
    return theme.transition.large;
  },
  get color() {
    return menu.item.color;
  },
  get bgColor() {
    return menu.bgColor;
  },
  light: {
    get color() {
      return menu.light.item.color;
    },
    get bgColor() {
      return menu.light.bgColor;
    },
    get border() {
      return menu.light.border;
    }
  },
  get collapsedWidth() {
    return "calc(" + getLeft(menu.item.padding) + " * 2 + " + menu.icon.width + ")";
  },
  footerPadding: '24px 50px'
  // bodyMargin: '0 20px',
};
var layout;
setDefault(function () {
  layout = deepDefaults(theme, {
    layout: defaults
  }).layout;
  makeLayoutStyles == null || makeLayoutStyles.clearCache();
  makeHeaderStyles == null || makeHeaderStyles.clearCache();
  makeAsideStyles == null || makeAsideStyles.clearCache();
  makeBodyStyles == null || makeBodyStyles.clearCache();
});
export function getCollapseWidth(collapsedWidth) {
  return isNullOrUndefined(collapsedWidth) ? layout.collapsedWidth : getStyle(collapsedWidth);
}
export var makeLayoutStyles = cache(function makeLayoutStyles(k) {
  return /*#__PURE__*/css("display:flex;flex-direction:column;flex:1;transition:padding-left ", layout.transition, ";&.", k, "-has-aside{flex-direction:row;}.", k, "-layout-footer{padding:", layout.footerPadding, ";}.", k, "-layout-body{flex:1;}");
});
export var makeHeaderStyles = cache(function makeHeaderStyles(k) {
  return /*#__PURE__*/css("display:flex;align-items:center;color:", layout.color, ";background:", layout.bgColor, ";left:0;transition:left ", layout.transition, ";&.", k, "-fixed{position:fixed;left:0;right:0;top:0;z-index:", theme.midZIndex + 1, ";}>.", k, "-menu{background:transparent!important;}&.", k, "-blur{backdrop-filter:blur(20px);background:", setAlpha(layout.bgColor, 0.1), ";}&.", k, "-box-shadow{border-bottom:none!important;box-shadow:", theme.boxShadow, ";}&.", k, "-light{background:", layout.light.bgColor, ";color:", layout.light.color, ";border-bottom:", layout.light.border, ";&.", k, "-blur{background:", setAlpha(layout.light.bgColor, 0.1), ";}}");
});
export var makeAsideStyles = cache(function makeAsideStyles(k) {
  return /*#__PURE__*/css("transition:width ", layout.transition, ";display:flex;flex-direction:column;background:", layout.bgColor, ";color:", layout.color, ";", _mapInstanceProperty(themes).call(themes, function (theme) {
    if (theme === 'dark') return;
    var styles = layout.light;
    return /*#__PURE__*/css("&.", k, "-", theme, "{background:", styles.bgColor, ";color:", styles.color, ";border-right:", styles.border, ";}");
  }), " &.", k, "-fixed{position:fixed;overflow:auto;left:0;top:0;bottom:0;z-index:", theme.midZIndex, ";}.", k, "-menu{width:auto!important;}");
});
export var makeBodyStyles = cache(function makeBodyStyles(k) {
  return /*#__PURE__*/css("transition:padding-left ", layout.transition, ";");
});